module.exports = __webpack_public_path__ + "static/media/united-states.02b347f4.svg";